"use client";
import * as e from "react";
function r() {
  const [, t] = e.useState({});
  return e.useCallback(() => {
    t({});
  }, []);
}
export {
  r as u
};
